export interface FormSubmission {
  id?: string;
  timestamp?: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address: string;
  source: string;
  orderStatus: string;
  willAttend: string;
  vehicleBrand: string;
  vehicleModel: string;
  vehicleYear: number;
  vehiclePlate: string;
  vehicleColor: string;
  serviceCity: string;
  vehicleLocation: string;
  inspectionDate: string;
  inspectionTime: string;
  notes?: string;
  ownerContact?: string;
  status?: string;
}

export const SOURCE_OPTIONS = [
  "Instagram",
  "Google",
  "Facebook",
  "Maps",
  "Threads",
  "Tiktok",
  "Teman/Keluarga/Kenalan",
  "Sosmed",
  "Lainnya",
] as const;

export const CITY_OPTIONS = [
  "Jogja",
  "Solo",
  "Semarang",
  "Bandung",
  "Surabaya",
] as const;

export const WILL_ATTEND_OPTIONS = [
  "Ya",
  "Tidak",
] as const;

export const ORDER_STATUS_OPTIONS = [
  "Customer Baru",
  "Repeat Order",
  "Lainnya",
] as const;
